// extracted by mini-css-extract-plugin
export default {"Badges":"styles_Badges__F1APL","HeaderButtonWrapper":"styles_HeaderButtonWrapper__ecIez","Icon":"styles_Icon__V9ONk","Button":"styles_Button__EFbNt"};